import { usePage } from "@tecnobit-srl/router";
import { Suspense, lazy } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/debug-bar.tsx
var Debug = lazy(() => import("./debug-component-C11hPPiS.js").then((module) => ({ default: module.DebugComponent })));
function DebugBar({ props }) {
	if (!usePage().user?.isAdmin && true) return null;
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: null,
		children: /* @__PURE__ */ jsx(Debug, { props })
	});
}
//#endregion
export { DebugBar };
